import { storyblokEditable } from "@storyblok/react";

const Item = ({ blok }) => (
  <div className="" {...storyblokEditable(blok)}>
    <li>{blok.listitem}</li>
  </div>
);

export default Item;